import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=11c2cf30&scoped=true"
import script from "./Step2.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Step2.vue?vue&type=style&index=0&id=11c2cf30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c2cf30",
  null
  
)

export default component.exports